import React from 'react';
import { cn } from '@/lib/utils';

export interface PageHeaderProps {
  title: string;
  description?: string;
  icon?: React.ReactNode;
  className?: string;
  children?: React.ReactNode;
}

export const PageHeader = React.forwardRef<HTMLDivElement, PageHeaderProps>(
  ({ title, description, icon, className, children, ...props }, ref) => {
    return (
      <div
        ref={ref}
        className={cn('mb-8', className)}
        {...props}
      >
        {/* Mobile-first responsive layout */}
        <div className="space-y-4 sm:space-y-0 sm:flex sm:items-start sm:justify-between">
          {/* Title and description - full width on mobile, flex-1 on desktop */}
          <div className="flex-1 min-w-0">
            <div className="flex items-center gap-2">
              {icon && <span className="text-foreground">{icon}</span>}
              <h1 className="text-2xl font-bold truncate sm:text-3xl text-foreground font-heading">
                {title}
              </h1>
            </div>
            {description && (
              <p className="mt-1 text-sm sm:text-base text-muted-foreground">
                {description}
              </p>
            )}
          </div>
          
          {/* Actions - stack on mobile, horizontal on desktop */}
          {children && (
            <div className="flex-shrink-0 sm:ml-4">
              <div className="flex flex-col gap-2 sm:flex-row sm:gap-2">
                {children}
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

PageHeader.displayName = 'PageHeader';
